
const Footer = () => {
  return (
    <section className="w-full h-auto pt-4">
        <div className="text-center max-w-[600px] m-auto">
            <h1 className='text-white font-extralight text-xl font-pacifico'>Created by Jecy Jehu</h1>
            <h2 className="text-gray-500">Moviedb Trailer</h2>
        </div>
    </section>
  )
}

export default Footer;